import React, {Component} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary, Chip,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup
} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {sortValueNice} from "../utils/filterHelper";

class BookSort extends Component {

    render() {
        // Parent Functions
        const sortBy = this.props.sortBy;
        const sortValue = this.props.sortValue;
        const filterValue = this.props.filterValue;

        const canSortByRead = () => {
            return filterValue !== "completed";
        }

        return (
            <div className="sort-container">
                <Accordion>
                    <AccordionSummary
                        expandIcon={<FontAwesomeIcon icon="chevron-down"/>}
                        aria-controls="sort-content"
                        id="sort-header"
                    >
                        <div className="title">Sort <Chip label={sortValueNice(sortValue)} className="title-chip"/></div>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl>
                            <FormLabel id="demo-controlled-radio-buttons-group">Title</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={sortValue}
                                onChange={(event) => sortBy(event.target.value)}
                            >
                                <FormControlLabel className="radio-label" value="title asc" control={<Radio />} label="A - Z" />
                                <FormControlLabel className="radio-label" value="title desc" control={<Radio />} label="Z - A" />
                            </RadioGroup>

                            <FormLabel id="demo-controlled-radio-buttons-group">Added</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={sortValue}
                                onChange={(event) => sortBy(event.target.value)}
                            >
                                <FormControlLabel className="radio-label" value="date asc" control={<Radio />} label="Old to New" />
                                <FormControlLabel className="radio-label" value="date desc" control={<Radio />} label="New to Old" />
                            </RadioGroup>

                            <FormLabel id="demo-controlled-radio-buttons-group">Published</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={sortValue}
                                onChange={(event) => sortBy(event.target.value)}
                            >
                                <FormControlLabel className="radio-label" value="published asc" control={<Radio />} label="Old to New" />
                                <FormControlLabel className="radio-label" value="published desc" control={<Radio />} label="New to Old" />
                            </RadioGroup>

                            <FormLabel id="demo-controlled-radio-buttons-group">Read</FormLabel>
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={sortValue}
                                onChange={(event) => sortBy(event.target.value)}
                            >
                                <FormControlLabel className="radio-label" value="read asc" control={<Radio />} label="Old to New" disabled={canSortByRead()} />
                                <FormControlLabel className="radio-label" value="read desc" control={<Radio />} label="New to Old" disabled={canSortByRead()} />
                            </RadioGroup>
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }

}


export default BookSort;
